import React, { useState } from 'react';
import {Segmented, Table, Card, Row, Col, Typography, Divider, Space} from 'antd';
import PnL from '../../../components/PnL';
import { stringMixin } from "../../../utils/strings";
import NivoScatterChart from "../../../charts/nivo/NivoScatterChart";
import { prepareBestWorstData } from "../utils";
import Explainer from "../../../components/Explainer";
import {NameColumn, RankColumn} from "../tableUtils";
import CumulativeRecoveryWaterfallChart from "../components/CumulativeRecoveryWaterfallChart";
import {Square} from "lucide-react";

const Risk = ({ items, itemColors }) => {
  const [window, setWindow] = useState('252');
  const [period, setPeriod] = useState('1 Year');

  const handleYearChange = (value) => {
    setPeriod(value);
    // Update window based on the selected period
    switch (value) {
      case '1 Year':
        setWindow('252');
        break;
      case '3 Year':
        setWindow('756');
        break;
      case '5 Year':
        setWindow('1260');
        break;
      default:
        setWindow('252'); // Default in case of an unexpected value
    }
  };

  const columns = [
      NameColumn(itemColors),
    {
      title: 'Best in Window',
      dataIndex: 'best',
      key: 'best',
      render: (value) => PnL({ value }),
      sorter: (a, b) => a.best - b.best,
    },
    {
      title: 'Worst in Window',
      dataIndex: 'worst',
      key: 'worst',
      render: (value) => PnL({ value }),
        sorter: (a, b) => a.worst - b.worst,
    },
    {
      title: 'Back to Even',
      dataIndex: 'backToEven',
      key: 'backToEven',
      render: (value) => stringMixin.pct(value),
      sorter: (a, b) => a.backToEven - b.backToEven,
    },
    {
      title: 'Beta',
      dataIndex: 'beta',
      key: 'beta',
      render: (value) => stringMixin.pct(value),
        sorter: (a, b) => a.beta - b.beta,
    },
    {
      title: 'Sharpe Ratio',
      dataIndex: 'sharpe',
      key: 'sharpe',
      render: (value) => value.toFixed(2),
        sorter: (a, b) => a.sharpe - b.sharpe,
    },
  ];

  const data = prepareBestWorstData(items, window);

  const nivoScatterData = data.map((d) => {
    return {
      id: d.label,
      data: [{ x: d.beta, y: d.sharpe }],
    };
  });

  const colors = {};
  items.forEach((x) => {
    colors[x.label] = itemColors[x.id];
  });

  const DrawdownLegend = ()=>{
    return (
        <Space>
            <Space>
                <Square size={16} style={{background: 'linear-gradient(#f63e3e, #732b2b)', color: "transparent", borderRadius:4}} />
                <span>Drawdown</span>
            </Space>
            <Space>
                <Square size={16} style={{background: 'linear-gradient(#1b5b42, #0dd083)', color: "transparent", borderRadius: 4}} />
                <span>Recovery</span>
            </Space>
        </Space>
    )
  }

  return (
    <div >
      <Segmented
            options={['1 Year', '3 Year', '5 Year']}
            value={period}
            onChange={handleYearChange}
            className={'mb-3'}
      />
      <div className={'p-1 round-2 mb-4'}>
        <Table columns={columns} dataSource={data} pagination={{pageSize: 10}} />
      </div>
      <Row gutter={[32, 32]} style={{ display: 'flex' }} className={'border-t border-gray-200'}>
        <Col xs={24} xl={12} style={{ display: 'flex', flexDirection: 'column' }} className={'border-r-2 border-gray-100'}>
          <Card bordered={false} className={'py-6'} title={<Explainer title={'Risk Premium'}/>} >
            <div style={{ height: '50vh', minHeight: 400 }}>
              <NivoScatterChart
                height={'100%'}
                data={nivoScatterData}
                keys={data.map((d) => d.label)}
                customColors={colors}
                axisLeftLegend={'Sharpe Ratio'}
                axisBottomLegend={'Beta'}
                dotSize={40}
                showLabels={true}
              />
            </div>
          </Card>
        </Col>
        <Col  xs={24} xl={12} style={{ display: 'flex', flexDirection: 'column' }}>
          <Card bordered={false} title={<Explainer title={'Cost of Drawdowns'} middle={<DrawdownLegend/>} /> } className={'py-6'}>
            <div style={{height: '50vh', minHeight: 200}}>
              <CumulativeRecoveryWaterfallChart data={data} />
            </div>
        </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Risk;
